import React from 'react';
import styled from 'styled-components';

const BackgroundBoxStyled = styled.div`
  background: var(--GrayScale-100);
  height: 10px;
  position: absolute;
  width: 100vw;

  left: -16px;
  top: 0;
`;

const BackgroundBox = () => {
  return <BackgroundBoxStyled></BackgroundBoxStyled>;
};

export default BackgroundBox;
